exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-list-item-group .v-list-item--active{\n  color:inherit\n}", ""]);
